<template>
    <div class="evaluation-scoped evaluation-society-scoped container">
        <div class="resume-doc-wpr box-shadow-small border-radius" v-if="baseInfo">
            <div class="" style="padding-top: 30px;">
                <div class="mb-15">
                    <thumbnail :text="baseInfo.resume.name" :gender="baseInfo.resume.gender==1?'man':'woman'" :font-size="16" :width="110"></thumbnail>
                    <el-row class="mt-10 text-center" :gutter="10">
                        <el-col :span="8">应聘职位：{{ baseInfo.position.name }}</el-col>
                        <el-col :span="8">应聘部门：{{ baseInfo.position.deptNames }}</el-col>
                        <el-col :span="8">手机号：{{ baseInfo.resume.mobilePhone }}</el-col>
                    </el-row>
                    <el-row class="mt-10 text-center" :gutter="10" v-if="canSync">
                        <el-col :span="8">同步供应商：{{evaInfo.syncInfo.isSync ? '已同步' : '未同步'}}</el-col>
                        <el-col :span="8" v-if="evaInfo.syncInfo.isSync">同步供应商时间：{{evaInfo.syncInfo.syncTime}}</el-col>
                    </el-row>
                </div>
            </div>
            <div v-if="!baseInfo.list.length && evaInfo && !evaInfo.list.length">
                <p style="margin: 100px 0;text-align: center;color: #ccc;"><i class="el-icon-information"></i>该应聘者还没有面试安排，不可添加面试评价</p>
            </div>
            <div v-else class="resume-doc">
                <div style="margin-top: 50px;" class="clearfix">
                    <el-button type="primary" @click="showEdit=true" v-if="!showEdit" :disabled="baseInfo.list.length ? showEdit : true" style="float: right;margin-bottom: 20px;">添加评价</el-button>
                    <el-button type="primary" @click="showEdit=false&&formKey++" v-if="showEdit" style="float: right;margin-bottom: 20px;">取消编辑</el-button>
                    <el-button type="primary" @click="syncToSupplier" style="float: right;margin-bottom: 20px;margin-right: 20px;" v-if="canSync">同步供应商</el-button>
                </div>
                <!--编辑评价表格-->
                <div class="edit-form" :key="formKey" v-if="showEdit">
                    <el-form ref="form" :inline="true" label-width="80px">
                        <el-form-item label="面试阶段">
                            <el-select v-model="interviewInfo.interviewArrangeId" placeholder="请选择面试阶段" @change="changePhase">
                                <el-option v-for="(item, index) in baseInfo.list" :label="item.turnName" :value="item.id" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="面试官">
                            <el-select v-model="interviewInfo.evaluator" placeholder="请选择面试官">
                                <el-option v-for="(item, index) in interviews" :label="item.name" :value="item.id" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div style="position: relative;" > 
                        <!-- <div class="mask-tip" v-if="!interviewInfo.evaluator">
                            <p>请先选择阶段和面试官{{baseInfo.position.advise}}</p>
                        </div> -->
                        <!--2017-08-24 一面、二面、三面···评分表修改为不做区分 isFull 统一设置成true -->
                        <society-form 
                            v-if="interviewInfo.evaluator"
                            :turn="turn"
                            :isSimple="evaInfo.isSimple"
                            :isFull="true"
                            :extInfo="interviewInfo"
                            :scoreType="baseInfo.position.scoreType"
                            :advise="baseInfo.position.advise"
                            :recruitType="evaInfo.recruitType" @refresh="addSuccess" @cancel="cancelEdit"></society-form>
                    </div>
                </div>
                <!--查看评价表格-->
                <div class="history-form" v-if="evaInfo && evaInfo.list.length">
                    <el-table class="evaluation-item" row-class-name="evaluate-row" :show-header="false"
                              v-for="(evaluate, index) in evaInfo.list" :data="[{}]" :key="index" v-if="evaluate.evaList.length">
                        <el-table-column width="200" class-name="name-td">
                            <template slot-scope="scope">{{evaluate.turnName}}评价结果</template>
                        </el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <div class="evaluate-row" v-for="(item, idx) in evaluate.evaList" :key="idx">
                                    <div class="isView">
                                        <el-row class="mt-15">
                                            <el-col :span="8"><span
                                                    class="txt-label">面试结果：</span>{{getSelectMapText('WB_USER_VIEWPOINT', item.userViewpoint)}}
                                            </el-col>
                                        </el-row>
                                        <el-row class="mt-15">
                                            <el-col :span="8"><span class="txt-label">面试官：</span>{{item.interviewer.name}}
                                            </el-col>
                                            <el-col :span="8"><span class="txt-label">时间：</span>{{item.evaluateTime}}
                                            </el-col>
                                        </el-row>

                                        <div v-if="!baseInfo.position.scoreType || !typeList.includes(baseInfo.position.scoreType)">
                                            <span>
                                                <el-row class="mt-15" v-if="!evaInfo.isSimple && baseInfo.position.scoreType">
                                                    <el-col :span="8" v-if="evaInfo.recruitType==='social'"><span class="txt-label">建议定级：</span>{{item.grade}}</el-col>
                                                    <el-col :span="8"><span class="txt-label">评分标准：</span>{{item.score}}</el-col>
                                                </el-row>
                                                <el-row class="mt-15 mb-15" v-else-if="evaInfo.isSimple">
                                                    <el-col><span class="txt-label">评价等级：</span><pre class="multi-row-content">{{item.grade}}</pre></el-col>
                                                </el-row>
                                            </span>
                                            <el-row class="mt-15 mb-15" v-if="!evaInfo.isSimple && baseInfo.position.scoreType">
                                                <el-col><span class="txt-label">面试记录：</span>
                                                    <pre class="multi-row-content">{{item.interviewRecord}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15"
                                                    v-if="!evaInfo.isSimple && evaInfo.recruitType==='social' && baseInfo.position.scoreType">
                                                <el-col>
                                                    <span class="txt-label">当前薪酬：</span>
                                                    <pre class="multi-row-content" v-if="item.monthBaseSalary">月薪{{item.monthBaseSalary}}*{{item.monthCount}}个月，{{item.otherWelfare}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15" v-if="!evaInfo.isSimple && baseInfo.position.scoreType">
                                                <el-col>
                                                    <span class="txt-label">{{['18', '19', '20'].includes(baseInfo.position.scoreType) ? '期望薪资：': '期望描述：'}}</span>
                                                    <pre class="multi-row-content">{{item.expectSalary}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15">
                                                <el-col><span class="txt-label">综合评价：</span>
                                                    <pre class="multi-row-content">{{item.content}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15" v-if="item.hireAdvice">
                                                <el-col><span class="txt-label">{{['18', '19', '20'].includes(baseInfo.position.scoreType) ? '岗位建议方向：': '录用方向建议：'}}</span>
                                                    <pre class="multi-row-content">{{item.hireAdvice}}</pre>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        
                                        <div v-if="['4', '5', '6', '7','8', '9', '10', '17', '21', '22', '23', '24'].includes(baseInfo.position.scoreType)">
                                            <el-row class="mt-15" v-if="baseInfo.position.scoreType !== '6'">
                                                <el-col><span class="txt-label">评分标准：</span>
                                                <pre class="multi-row-content">{{item.score}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15">
                                                <el-col >
                                                    <span class="txt-label">建议薪资：</span>
                                                    <pre class="multi-row-content">{{item.adviceSalary}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15" v-if="baseInfo.position.scoreType==='6' || baseInfo.position.scoreType==='7' ||  baseInfo.position.scoreType==='8'">
                                                <el-col>
                                                    <span class="txt-label">当前薪资：</span>
                                                    <pre class="multi-row-content" v-if="item.monthBaseSalary">月薪{{item.monthBaseSalary}}*{{item.monthCount}}个月，{{item.otherWelfare}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15">
                                                <el-col >
                                                    <span class="txt-label">期望薪资：</span>
                                                    <pre class="multi-row-content">{{item.expectSalary}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15" >
                                                <el-col>
                                                    <span class="txt-label">面试记录：</span>
                                                    <pre class="multi-row-content">{{item.interviewRecord}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15">
                                                <el-col>
                                                    <span class="txt-label">综合评价：</span>
                                                    <pre class="multi-row-content">{{item.content}}</pre></el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15" v-if="item.hireAdvice">
                                                <el-col><span class="txt-label">{{['17', '21', '22', '23', '24'].includes(baseInfo.position.scoreType) ? '岗位建议方向：': '录用方向建议：'}}</span>
                                                    <pre class="multi-row-content">{{item.hireAdvice}}</pre>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <div v-if="['11', '12', '13'].includes(baseInfo.position.scoreType)">
                                            <div v-if="['12','13'].includes(baseInfo.position.scoreType) && evaluate.turn === '0'">
                                                <el-row
                                                    v-for="(scoreMap, index) in scoreMapList"
                                                    :key="scoreMap.name"
                                                    :class="[ [0,6].includes(index) ? 'mt-15' : 'mt-5' ]"
                                                >
                                                    <el-col>
                                                        <span class="txt-label">{{ [6,7,8].includes(index) ? '个人素质' : '综合能力' }}-{{ scoreMap.name }}：</span>
                                                        <pre class="multi-row-content" v-if="item[scoreMap.prop]">{{ item[scoreMap.prop] }}</pre>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <el-row class="mt-15" v-if="baseInfo.position.scoreType === '12' && evaluate.turn === '0'">
                                                <el-col>
                                                    <span class="txt-label">专业能力：</span>
                                                    <pre class="multi-row-content" v-if="item.professionalProjMgr">{{ item.professionalProjMgr }}</pre>
                                                </el-col>
                                            </el-row>
                                            <div v-if="baseInfo.position.scoreType === '13' && evaluate.turn === '0'">
                                                <el-row
                                                    v-for="(skillMap, index) in skillMapList"
                                                    :key="skillMap.name"
                                                    :class="[ index ? 'mt-5' : 'mt-15' ]"
                                                >
                                                    <el-col>
                                                        <span class="txt-label">专业能力-{{ skillMap.name }}：</span>
                                                        <pre class="multi-row-content" v-if="item[skillMap.prop]">{{ item[skillMap.prop] }}</pre>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div v-if="['12','13'].includes(baseInfo.position.scoreType) && evaluate.turn === '0'">
                                                <el-row
                                                    v-for="(otherMap, index) in otherMapList"
                                                    :key="otherMap.name"
                                                    :class="[ index ? 'mt-5' : 'mt-15' ]"
                                                >
                                                    <el-col>
                                                        <span class="txt-label">其他-{{ otherMap.name }}：</span>
                                                        <pre class="multi-row-content" v-if="item[otherMap.prop]" style="width: 690px;">{{ item[otherMap.prop] }}</pre>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <el-row class="mt-15" v-if="evaluate.turn === '0'">
                                                <el-col>
                                                    <span class="txt-label">当前薪资：</span>
                                                    <pre class="multi-row-content" v-if="item.monthBaseSalary">月薪{{item.monthBaseSalary}}*{{item.monthCount}}个月，{{item.otherWelfare}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15" v-if="evaluate.turn === '0'">
                                                <el-col >
                                                    <span class="txt-label">期望薪资：</span>
                                                    <pre class="multi-row-content">{{item.expectSalary}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15" v-if="['12','13'].includes(baseInfo.position.scoreType) && evaluate.turn === '0'">
                                                <el-col >
                                                    <span class="txt-label">最快到岗时间：</span>
                                                    <pre class="multi-row-content" v-if="item.lastEntryTime">{{item.lastEntryTime}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15">
                                                <el-col>
                                                    <span class="txt-label">综合评价：</span>
                                                    <pre class="multi-row-content">{{item.content}}</pre></el-col>
                                            </el-row>
                                        </div>

                                        <div v-if="['14', '15', '16'].includes(baseInfo.position.scoreType)">
                                            <el-row class="mt-15">
                                                <el-col ><span class="txt-label">评分标准：</span>{{item.score}}</el-col>
                                            </el-row>
                                            <el-row class="mt-15">
                                                <el-col ><span class="txt-label">期望薪资：</span>
                                                    <pre class="multi-row-content">{{item.expectSalary}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15" >
                                                <el-col><span class="txt-label">面试记录：</span>
                                                    <pre class="multi-row-content">{{item.interviewRecord}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15">
                                                <el-col >
                                                    <span class="txt-label">综合评价：</span>
                                                    <pre class="multi-row-content">{{item.content}}</pre>
                                                </el-col>
                                            </el-row>
                                            <el-row class="mt-15 mb-15" v-if="item.hireAdvice">
                                                <el-col><span class="txt-label">录用方向建议：</span>
                                                    <pre class="multi-row-content">{{item.hireAdvice}}</pre>
                                                </el-col>
                                            </el-row>
                                </div>
                                        <el-button size="small" style="position: absolute;right: 0px;bottom: 10px;" @click="showEditPopup(item, evaluate)">编辑</el-button>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog
                title="修改评价"
                :close-on-click-modal="false"
                :visible.sync="dialogVisible">
            <div class="isEdit" v-if="dialogInfo && baseInfo && evaInfo">
                <!--2017-08-24 一面、二面、三面···评分表修改为不做区分 isFull 统一设置成true -->
                <society-form 
                    :turn="dialogInfo.turn"
                    :isSimple="evaInfo.isSimple"
                    ref="updateForm"
                    :isEdit="true"
                    :isFull="true"
                    :extInfo="dialogInfo.extInfo"
                    :scoreType="baseInfo.position.scoreType"
                    :advise="baseInfo.position.advise"
                    :recruitType="evaInfo.recruitType" @refresh="updateSuccess" @cancel="dialogVisible = false"></society-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Thumbnail from 'components/thumbnail'
    import SocietyForm from './society-form/society-form'
    import SelectMapMixin from 'mixins/selectMapMixin'
    import {
        scoreMapList,
        otherMapList,
        skillMapList
    } from './libs'

    export default {
        components: {
            Thumbnail, SocietyForm
        },
        mixins: [SelectMapMixin],
        data () {
            return {
                typeList: ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '21', '22', '23', '24'], // 新增四张表的scoreType
                baseInfo: null,  // 基本信息
                evaInfo: null,
                formKey: 1,
                showEdit: false,
                interviews: [],
                turn: null,
                dialogVisible: false,
                interviewInfo: {
                    interviewArrangeId: null,
                    evaluator: ''
                },
                dialogInfo: {
                    turn: '',
                    extInfo: ''
                },
                form: {
                    status: '',
                    content: ''
                },
                scoreMapList,
                otherMapList,
                skillMapList
            }
        },
        created () {
            this.getPhaseInfo()
            this.getEvaList()
        },
        computed: {
            canSync () {
                return this.evaInfo && this.evaInfo.syncInfo && this.evaInfo.syncInfo.canSync
            }
        },
        methods: {
            getPhaseInfo () {
                this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', {resumePositionId: this.$route.params.id}).then(res => {
                    this.baseInfo = res.result
                })
            },
            getEvaList () {
                this.$axios.get('/evaluation/getEvaList.api?resumePositionId=' + this.$route.params.id).then(res => {
                    this.evaInfo = res.result
                })
            },
            refresh () {
                this.getEvaList()
            },
            changePhase (val) {
                let turnInfo = this.baseInfo.list.filter(item => item.id === val)[0]
                let masterIds = turnInfo.masterInterviewer.split(','),
                    masterNames = turnInfo.masterInterviewerNames.split('，')
                this.interviews = []
                masterIds.forEach((mid, mindex) => {
                    this.interviews.push({
                        id: mid,
                        name: masterNames[mindex]
                    })
                })
                this.interviewInfo.evaluator = ''
                this.turn = turnInfo.turn
            },
            cancelEdit () {
                this.showEdit = false
            },
            updateSuccess () {
                this.refresh()
                this.dialogVisible = false
            },
            addSuccess () {
                this.refresh()
                this.showEdit = false
                this.interviewInfo.interviewArrangeId = ''
                this.interviewInfo.evaluator = ''
                this.getPhaseInfo()
                this.formKey++
            },
            showEditPopup (item, evaluate) {
                this.dialogInfo.extInfo = {
                    resumePositionId: evaluate.resumePositionId,
                    interviewArrangeId: evaluate.id
                }
                this.dialogInfo.turn = evaluate.turn
                this.dialogVisible = true
                this.$nextTick(() => {
                    this.$refs.updateForm.setForm(item)
                })
            },
            syncToSupplier () {
                this.$confirm('同步后供应商可查看面试评价信息，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post('/evaluation/syncEva.api', {
                        resumePositionIds: this.$route.params.id
                    }).then(res => {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        })
                        this.refresh()
                    })
                }).catch(() => {})
            }
        }
    }
</script>

<style lang="scss">
    @import "./evaluation";
    .evaluation-society-scoped{
        .mask-tip{
            position: absolute;
            left: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.1);
            text-align: center;
            width: 100%;
            height: 100%;
            z-index: 20;
            p{
                position: absolute;
                width: 100%;
                top: 48%;
            }
        }
        .evaluate-row{
            position: relative;
            border-bottom: 1px dashed #ddd;
            padding: 10px 0;
            margin-bottom: -1px;
        }
    }
</style>



// WEBPACK FOOTER //
// society.vue?00722892